import React, { useState } from "react";
import { CategoriesIcon } from "../../../assets/img/CategoriesIcon";
import {
  CategoriesFilterValue,
  FilterWrapper,
  MarketplaceFilterButton,
  MarketplaceFilterDropdownCategories,
  MarketplaceFilterDropdownSaleType,
} from "./MarketplaceFilter.styled";

const saleType = ["Аll Types", "On Sаle", "Not For Sаle"];

export const SaleTypeFilter = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [active, setActive] = useState("Аll Types");
  return (
    <FilterWrapper
      onMouseLeave={() => {
        setShowDropdown(false);
      }}>
      <MarketplaceFilterButton
        onMouseEnter={() => {
          setShowDropdown(true);
        }}>
        Sale Type
      </MarketplaceFilterButton>
      <MarketplaceFilterDropdownSaleType showDropdown={showDropdown}>
        {saleType.map((type, i) => (
          <CategoriesFilterValue
            active={type === active && true}
            onClick={() => {
              setActive(type);
            }}
            key={i}>
            {type}
          </CategoriesFilterValue>
        ))}
      </MarketplaceFilterDropdownSaleType>
    </FilterWrapper>
  );
};
